import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormField } from '../components/FormField';
import { Button } from '../components/Button';
import { forgot } from '../api/auth';
import { ApiError } from '../api/client';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function ForgotPassword() {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [email, setEmail] = useState(search.get('email') ?? '');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) {
      setErrors({ email: 'Enter a valid email address.' });
      return;
    }
    setErrors({});
    setSubmitting(true);
    try {
      await forgot(email.trim().toLowerCase());
      navigate(`/forgot-confirm?email=${encodeURIComponent(email.trim().toLowerCase())}`);
    } catch (err) {
      const e2 = err as ApiError;
      setErrors({ form: e2.message || 'Could not start the reset. Try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <h1 style={{ marginBottom: 8 }}>Forgot password</h1>
      <p style={{ color: 'var(--muted)', marginBottom: 24 }}>
        Enter the email on your account. We'll send you a code to reset your password.
      </p>

      <FormField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} error={errors.email} required />
      {errors.form ? <p style={{ color: 'var(--error)', fontSize: 14 }}>{errors.form}</p> : null}
      <Button label="Send the code" type="submit" loading={submitting} style={{ marginTop: 16, width: '100%' }} />
    </form>
  );
}
